import { request } from '../utils';

export default ( baseUrl, cache ) => ( ctx, payload = {}) => {
  let param = payload.id ? ('?id=' + payload.id) : '';
  return request( ctx, baseUrl + '/get' + param, payload, cache, 'get' );
};
